import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { VehicleconfigService } from '../vehicleconfig.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-vehicleconfig-list',
  templateUrl: './vehicleconfig-list.component.html',
  styleUrls: ['./vehicleconfig-list.component.scss']
})
export class VehicleconfigListComponent implements OnInit {

  constructor(private router: Router,
    private globalFunctionService: GlobalFunctionsService,
    private vehicleConfigService: VehicleconfigService) { }

  // ViewChild
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];
  pageSize = 10;
  userLogin: UserLogin;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Código',
      field: 'VehicleKey',
      width: 10,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Descripción',
      field: 'VehicleDescription',
      width: 40,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Editar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childEditRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    },
    {
      headerName: 'Eliminar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childDeleteMessageRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    }
  ];

  ngOnInit(): void {
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getVehicleConfig();
  }

  onPageSizeChange(value: number) {
    console.log(value);
  }

  getVehicleConfig() {
    this.vehicleConfigService.getVehicleConfigList().subscribe(data => {
      this.ceqGrid.data = data;
    });
  }

  btnAddClick() {
    this.router.navigate(['/tax/vehicleconfig/create']);
  }

  edit(row: any) {
    this.router.navigate(['/tax/vehicleconfig', row.data.VehicleKey]);
  }

  async delete(row: any) {
    const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar la configuración vehicular " + row.data.VehicleKey + "?", 'question1', 'Confirmacion');
    if (result) {
      this.vehicleConfigService.deleteVehicleConfig(row.data.VehicleKey).subscribe(async data => {
        console.log("result", data);
        await this.globalFunctionService.messageBimbo('La configuración se eliminó correctamente.', 'success', '¡Éxito!');
      }, async (error) => {
        console.log("error", error);
        await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
      }, () => {
        this.getVehicleConfig();
      });
    }
  }


}
